module.exports = __webpack_public_path__ + "img/idcardback.9e72aa16.png";